import { Component, OnDestroy, OnInit } from '@angular/core'
import { BreakpointService, ProductFacetNavigationComponent } from '@spartacus/storefront'
import { Subscription } from 'rxjs'
import { EbProductListComponentService } from '../../services/facades/eb-product-list-component.service'

@Component({
    selector: 'eb-product-facet-navigation',
    templateUrl: './eb-product-facet-navigation.component.html',
    styleUrls: ['./eb-product-facet-navigation.component.scss'],
    standalone: false
})
export class EbProductFacetNavigationComponent extends ProductFacetNavigationComponent implements OnInit, OnDestroy{

  unitChangeSubscription: Subscription = new Subscription()

  constructor(
    protected breakpointService: BreakpointService,
    protected ebProductListComponentService: EbProductListComponentService
  ){
    super(breakpointService)
  }

  ngOnInit(): void {
    this.unitChangeSubscription = this.ebProductListComponentService.triggerSearchOnUnitChange()
  }

  ngOnDestroy(): void {
    this.unitChangeSubscription.unsubscribe()
  }
}